import { useEffect, useState } from 'react';

import type { BreakPoint } from '@/common/hooks/useBreakPoint';
import type { NoGroupsMatchType } from '@/common/hooks/useBreakPointGroups';
import { useBreakPointGroups } from '@/common/hooks/useBreakPointGroups';

import type { SplitViewState } from './SplitViewContext';

const lessThanLarge: BreakPoint[] = ['small', 'medium'];
const largeAndUp: BreakPoint[] = ['large', 'xlarge'];

const breakPointGroups = {
  lessThanLarge,
  largeAndUp
};

function getViewState(
  currentBreakPointGroup: keyof typeof breakPointGroups | NoGroupsMatchType,
  hasTextPanel: boolean
): SplitViewState {
  if (hasTextPanel) {
    return currentBreakPointGroup === 'lessThanLarge'
      ? 'TextPanelOverMap'
      : 'SideBySide';
  }
  return 'MapPanel';
}

export function useSplitViewState(hasTextPanel: boolean) {
  const currentBreakPointGroup = useBreakPointGroups(breakPointGroups);
  const [splitViewState, setSplitViewState] = useState<SplitViewState>(
    getViewState(currentBreakPointGroup, hasTextPanel)
  );

  useEffect(() => {
    const newState = getViewState(currentBreakPointGroup, hasTextPanel);
    if (newState !== splitViewState) {
      setSplitViewState(newState);
    }
  }, [currentBreakPointGroup, splitViewState, hasTextPanel]);

  return splitViewState;
}
